module.exports = __webpack_public_path__ + "static/media/hat-witch.18c96576.svg";